module.exports = __webpack_public_path__ + "static/media/9391ffa3-2cb4-4a66-b4eb-eb2f3284dfa6.1f1e08e7.webp";